import StatLine from './StatLine.vue'

export default StatLine
